import { AwsRum } from "aws-rum-web";

let rum = null;

export function initAwsRum() {
  // Prevent double initialization
  if (rum) return rum;

  // Optional: disable in local dev
  if (process.env.NODE_ENV === "development") {
    return null;
  }

  try {
    const config = {
      sessionSampleRate: 1,
      identityPoolId: "eu-central-1:a6ee4bf5-e7da-4e64-be17-863de42a0d00",
      endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: true,
      signing: true,
    };

    rum = new AwsRum("6b8d3dd2-6ffd-4c62-b1fe-91c7b97ed61d", process.env.REACT_APP_VERSION || "unknown", "eu-central-1", config);

    return rum;
  } catch (err) {
    // RUM should never break the app
    console.warn("AWS RUM init failed", err);
    return null;
  }
}
